import React, { type FunctionComponent } from 'react'
import { colors, spacing } from '@retailer-platform/shared-components'
import { SVGIcon } from 'ic-snacks'
import styled from '@emotion/styled'

interface Props {
  deleteRule: () => void
}

const Wrapper = styled.div({
  marginTop: spacing.X16,
})

export const CollectionsRuleDelete: FunctionComponent<Props> = ({ deleteRule }) => (
  <Wrapper onClick={deleteRule}>
    <SVGIcon
      css={{
        cursor: 'pointer',
      }}
      color={colors.DETRIMENTAL.REGULAR}
      name="deleteFilled"
    />
  </Wrapper>
)
